import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from 'config/api';

const portfolioApi = createApi({
  reducerPath: 'portfolioApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
  }),
  endpoints: (builder) => ({
    getProject: builder.query({
      query: (id = null) => 'project' + (id ? `?service_id=${id}` : ''),
    }),
    getProjectById: builder.query({
      query: (id) => `project/${id}`,
    }),
  }),
});

export const { useGetProjectQuery, useGetProjectByIdQuery } = portfolioApi;

export default portfolioApi;
